/*========================search=============================*/
let viewMoreURL = '';
let request_count = 0;
let response_count = 0;
let school_chunk_limit = 10;
let searchParams = searchParamsObj;
let urlParams = new URLSearchParams(window.location.search);
let urlHaveParams = new URLSearchParams(window.location.search);
let all_tags = [];


if (initResponse && "params_passed" in initResponse && "limit" in initResponse.params_passed) school_chunk_limit = initResponse.params_passed.limit;
let page = (parseInt(initResponse.page_number)) ? parseInt(initResponse.page_number) : 1;
if (DD_SEARCH_PG || typeof (initResponse.schools) == 'undefined') initResponse.schools = [];
let jsonSearchData = (initResponse.schools) ? initResponse.schools : [];
let schoolTotalCount = (initResponse.total_count) ? initResponse.total_count : initResponse.schools.length;
let updateURL = '';
let cityLat = '';
let cityLng = '';
let pageVisitTypeForFilter = pageVisitType;
const defaultRangeForTag = {1: 30, 2: 10, 5: 5};
let userFirstSearchUrl = '';

if (initResponse.view_more) {

		viewMoreURL = `${HOST}/${decodeURIComponent(initResponse.view_more).trim().replace(/&amp;/g, '&')}`;
		if (pageVisitType === 'SEO' || pageVisitType === 'DEDICATED_SEARCH_PAGE') $('#loadMoreSeoButton').attr('href', viewMoreURL);
} else $('#loadMoreSeoButton').hide();


/*========================/search=============================*/

$(function () {

	/* store search url when user comes first */
		userFirstSearchUrl = window.location.href;

		if(pageVisitType === 'SEARCH'){
			$('#clearAllFilters').on('click', function(e){
				e.preventDefault();

				window.location.href = userFirstSearchUrl;

			})
		}

		if (!!pageVisitType) {
				if (['SEO', 'DEDICATED_SEARCH_PAGE'].includes(pageVisitType)) {
						sessionStorage.setItem('homepageSearchSession', true);
						if ($('.school-details-wrapper').length) NewZealandLead();
				}
		}

		if ($('#schoolFilterModal').length) {
				$('#schoolFilterModal').on('shown.bs.modal', () => {
						openFirstFilter();
				});
		}


		let cityLatElm = $("#latitude");
		let cityLngElm = $("#longitude");
		cityLat = cityLatElm.val();
		cityLng = cityLngElm.val();

		/*======= highlight toggle effect ==============*/
		$('.toggle-highlight-content').on('click', function () {
				const toggleButton = $(this);
				const contentContainer = toggleButton.parent().next('.highlight-section-content');
				const isHighlight = contentContainer.attr('data-highlight');
				
				contentContainer.toggleClass('collapsed');
				
				if(!!isHighlight) contentContainer.toggleClass('how-extra-highlights');
				
				toggleButton.text(contentContainer.hasClass('collapsed') ? 'Show More' : 'Show Less');
		});
		/*======= /highlight toggle effect ==============*/

		/*======= seo content toggle effect ==============*/
		const toggleSeoContentBtn = $('.btn-toggle-content');
	toggleSeoContentBtn.on('click', function () {
			const toggleButton = toggleSeoContentBtn;
			const contentContainer = $('.seo-details-highlights-content');
			// const isHighlight = contentContainer.attr('data-highlight');

			contentContainer.toggleClass('collapsed');

			// if(!!isHighlight) contentContainer.toggleClass('how-extra-highlights');
			if(contentContainer.hasClass('collapsed')){

				$('html, body').animate({
					scrollTop: $('.sorting-title').offset().top
				}, 1000);

				$('.secondary-btn').addClass('d-none').removeClass('d-inline-block');
				$('.near-content').removeClass('d-none').addClass('d-inline-block');

			}else{
				$('.secondary-btn').addClass('d-inline-block').removeClass('d-none');
				$('.near-content').removeClass('d-inline-block').addClass('d-none');
			}

			toggleButton.text(contentContainer.hasClass('collapsed') ? 'Read More' : 'Read Less');
		});
		/*======= /highlight toggle effect ==============*/

		/*==================Read more==========================*/
		readMoreComment();
		/*==================/Read more==========================*/

		/*================== shortlist ==========================*/
		bindWishListClicks();
		/*================== /shortlist ==========================*/

		/*==================update header search dropdown==========================*/
		if (!!schoolType) {
				$('.updateDropdownToggleSchoolType').find(`[data-school-type=${schoolType}]`).trigger('click');
		}
		/*==================/update header search dropdown==========================*/

		/*========================school main filters=============================*/

		displayFields(schoolType);

		$('.filter-container input[type=checkbox]').on('change', function (e) {
				e.preventDefault();

				resetPageData();

				let currentFilter = $(this);

				if (pageType === 'SEO') {
						sessionStorage.setItem('homepageSearchSession', true);
				}

				/* scroll top page on search page */
				if (pageType === 'SEARCH') $('html, body').animate({scrollTop: $('#school-tile-container').offset().top - 200}, 800);
				/* scroll top page on search page */

				cityLat = !!cityLat ? cityLat : latitude;
				cityLng = !!cityLng ? cityLng : longitude;

				if (DD_SEARCH_PG && schoolType === 3) {
						cityLatElm.attr('value', '');
						cityLngElm.attr('value', '');
						cityLat = '';
						cityLng = '';
				}

				SeoViewMore(pageVisitType, viewMoreURL);

				if ([6, 3].includes(parseInt(schoolType)) || (([1, 2, 5].includes(parseInt(schoolType))) && cityLat !== '' && cityLng !== '')) ajaxSearch();

			updateAppliedFilters();

		});

		/*========================/school main filters=============================*/

		/*=============================== load school ========================================*/
		/*if (!['SEO', 'DEDICATED_SEARCH_PAGE'].includes(pageVisitType)) {
				CheckResultLoaded(jsonSearchData, schoolTotalCount);
		}*/
		/*=============================== /load school ========================================*/

		/*=============================== login alert on search modal ========================================*/
		blurLoginEffectHTML();
		/*=============================== login alert on search modal ========================================*/

		/*=============================== Blur effect on load more ========================================*/
		/*$(window).scroll(function () {
				BlurHtmlOnScroll();
		});*/
		/*=============================== Blur effect on load more ========================================*/

		/*=============================== Removing Spacing from seo top content ========================================*/
		$("#seoTopContent p").filter(function () {
				if ($(this).text().trim() === '') $(this).hide();
		});
		/*=============================== /Removing Spacing from seo top content ========================================*/

		/*=============================== GA event on seo page ========================================*/
		if (pageVisitType && pageVisitType === 'SEO' && jsonSearchData && jsonSearchData.length > 0) generateImpressionEA(jsonSearchData);
		/*=============================== /GA event on seo page ========================================*/

		/*=============================== highlight Class for filters in mobile view ========================================*/
		$('.all-filters .filter').on('click', function (e) {
				e.preventDefault();
				let filterType = $(this);
				if (filterType.hasClass('sort-filter')) {
						filterType.css('z-index', 1051);
				} else {
						filterType.siblings().css('z-index', 1);
				}
		});

		/* remove z-index from sort filter in mobile view after modal hidden */
		if ($('#sortFilterModal').length) {
				$('#sortFilterModal').on('hide.bs.modal', () => {
						$('.all-filters .filter').css('z-index', 1)
				});
		}

		/*=============================== /highlight Class for filters in mobile view ========================================*/

		if ($('.loadMoreBtn').length) {
				$('.loadMoreBtn').on('click', function () {
						if (pageType === 'SEO') {
								sessionStorage.setItem('homepageSearchSession', true);
						}
				});
		}

	$('.toggleSeoPageContent').click(function (e) {
		const seoContentContainer = $('.seo-child-container');
		const btn = $(this);
		seoContentContainer.toggleClass('collapsed');
		if(seoContentContainer.hasClass('collapsed')){
			btn.text(btn.text().replace('Less', 'More'));
			scrollToTop($('#seoTopContent'), 100);
		}else{
			btn.text(btn.text().replace('More', 'Less'));
		}
	});

});


function displayFields(schoolType) {

		// check and update filters
		let selectedFilters = $('#tags').val();
		let allFilters = $('.filter-wrapper input');
		selectedFilters = selectedFilters.split(", ");
		let city_name = $('#city_name').val();
		let formatted_address = $('#formatted_address').val();

		/* fix for boarding school with location city */
		if(pageVisitType === 'SEO' && !!city_name){
				sessionStorage.setItem('addBoardingLocation', '1');
		}

		if(pageVisitType === 'SEO' && !city_name){
				sessionStorage.removeItem('addBoardingLocation');
		}

		if(pageVisitType === 'DEDICATED_SEARCH_PAGE' && !!city_name && (parseInt(schoolType) !== 3)){
				sessionStorage.setItem('addBoardingLocation', '1');
		}

		if(pageVisitType === 'DEDICATED_SEARCH_PAGE' && !!city_name && (parseInt(schoolType) === 3)){
				sessionStorage.removeItem('addBoardingLocation');
		}

		if(pageVisitType === 'SEARCH' && !!window.location.href.includes('city')){
				sessionStorage.setItem('addBoardingLocation', '1');
		}

		if(pageVisitType === 'SEARCH' && !window.location.href.includes('city')){
				sessionStorage.removeItem('addBoardingLocation');
		}

		if(pageVisitType === 'SEARCH' && !window.location.href.includes('city_name') && !window.location.href.includes('state_name') && (parseInt(schoolType) !== 3)){
				sessionStorage.setItem('addBoardingLocation', '1');
		}

		// custom condition for old search query
		if(pageVisitType === 'SEARCH' && !!window.location.href.includes('city2') && !!window.location.href.includes('state')){
				sessionStorage.removeItem('addBoardingLocation');
		}

		if(window.location.href.includes('range_max')){
				let getCurrentUrl = window.location.href;
				if(getCurrentUrl.includes('range_max')){
						let getRangeMax = getParameterByName('range_max', getCurrentUrl);
						if(!!getRangeMax) sessionStorage.setItem('addRangeMax', getRangeMax);
				}

		}else{
				sessionStorage.removeItem('addRangeMax');
		}

		/*allFilters.each((i, filter) => {
				let currentFilter = $(filter);
				if (selectedFilters.find(filter => (currentFilter.val()).includes(filter))) currentFilter.prop('checked', true);
		});*/

		// schoolType = parseInt(schoolType) === 4 ? '3' : parseInt(schoolType);
		let placeLevel = parseInt($("#place_level").val());
		let level = (placeLevel === "administrative_area_level_1") ? 1 : 0;
		/*let URLRangeMax = parseInt($('#URLrangemax').val());
		let sliderRangeMax = (URLRangeMax === 30) ? URLRangeMax : 10;
		if (isNaN(URLRangeMax)) URLRangeMax = (parseInt(schoolType) === 2) ? 3 : 5;*/

		let distanceRangeMax = 10;
		let distanceRangeSteps = 1;
		if (parseInt(schoolType) === 1) {
				distanceRangeMax = 30; //day school range max
				distanceRangeSteps = 5;
		}
		if (parseInt(schoolType) === 2) {
			distanceRangeSteps = .5;
		}

		let currentDistanceRangeMax = distanceRangeMax;
		let currentDistanceRangeMin = 0;

		if(!!searchParams.city_id && [1, 5].includes(parseInt(schoolType))){ // update range slider in case of city id
				distanceRangeMax = 50;
		}

		/* select filters by search parmas obj */
		if (pageVisitType) {
				// dynamic boards if exists
				if (!!searchParams.board_id_arr_query) {
						let boardIdsObj = searchParams.board_id_arr_query;
						for (let key in boardIdsObj) {
								if([1, 7, 12, 13].includes(parseInt(boardIdsObj[key]))) $(`#board-1`).prop('checked', true)
								if([3, 14, 15, 16, 17].includes(parseInt(boardIdsObj[key]))) $(`#board-3`).prop('checked', true)
								if([2, 8, 11].includes(parseInt(boardIdsObj[key]))) $(`#board-11`).prop('checked', true)
								if([6,18, 19].includes(parseInt(boardIdsObj[key]))) $(`#board-19`).prop('checked', true)
								if([4, 5, 9, 20, 21].includes(parseInt(boardIdsObj[key]))) $(`#board-4`).prop('checked', true)
						}
				}

				// dynamic classification if exists
				if (!!searchParams.coed_type_id_arr && searchParams.coed_type_id_arr.length) {
						let coedArr = searchParams.coed_type_id_arr;
						coedArr.map((coedId) => $(`input[value=coed-${coedId}]`).prop('checked', true));
				}

				// dynamic region if exists
				if (!!searchParams.region_id_arr && searchParams.region_id_arr.length) {
						let regionIdsArr = searchParams.region_id_arr;
						regionIdsArr.map((regionId) => $(`#region-${regionId}`).prop('checked', true));
				}

				// dynamic category if exists
				if (!!searchParams.category_id_arr && searchParams.category_id_arr.length) {
						let categoryIdsArr = searchParams.category_id_arr;
						categoryIdsArr.map((categoryId) => $(`#category-${categoryId}`).prop('checked', true));
				}

				// dynamic facility if exists
				if (!!searchParams.facility_name_arr && !$.isEmptyObject(searchParams.facility_name_arr)) {
						let facilityObj = searchParams.facility_name_arr;
						for (const facility of facilityObj) {
								$(`#facility-${facility}`).prop('checked', true);
						}
				}

				// dynamic fees if exists
				if (!!searchParams.fee_min_max_arr && searchParams.fee_min_max_arr.length) {
						let feeArr = searchParams.fee_min_max_arr;
						feeArr.map((fee) => {
								let feeStr = '';
								if (fee.hasOwnProperty('min')) feeStr += 'fee->' + fee.min;
								if (fee.hasOwnProperty('max') && fee.hasOwnProperty('min')) feeStr += '_<' + fee.max;
								if (!fee.hasOwnProperty('min')) feeStr = 'fee_>' + fee.max;
								if (!fee.hasOwnProperty('min') && fee.hasOwnProperty('max')) feeStr = 'fee-<' + fee.max;

								$(`input[value="${feeStr}"]`).prop('checked', true)
						});
				}

				// dynamic school if exists
				if (!!searchParams.pg_school_id_arr && searchParams.pg_school_id_arr.length) {
						let pg_school_id_arr = searchParams.pg_school_id_arr;
						pg_school_id_arr.map((schoolId) => $(`#pg_school_${++schoolId}`).prop('checked', true));
				}

		}

		let searchSessionData = JSON.parse(localStorage.getItem('searchSessionData'));
		let homepageSearchSession = sessionStorage.getItem('homepageSearchSession');
		const {
				latitude: spLatitude = null,
				longitude: spLongitude = null,
				city_name: spCityName = null,
				locality_obj = {}
		} = searchParamsObj || {};

		const {name: localityName = null} = locality_obj || {};

		if (!!searchSessionData) {
				if ((spLatitude != searchSessionData.latitude) && (spLongitude != searchSessionData.longitude)) {
						sessionStorage.setItem('homepageSearchSession', true);

						if (!!spCityName && !!localityName && spCityName !== 'undefined' && localityName !== 'undefined') {
								$('#formatted_address').val(`${localityName}, ${spCityName}`);
						} else if (!!spCityName && spCityName !== 'undefined') {
								$('#formatted_address').val(spCityName);
						}

				} else {
						// sessionStorage.setItem('addBoardingLocation', '1');
						sessionStorage.removeItem('homepageSearchSession');
				}
		} else {
				sessionStorage.setItem('homepageSearchSession', true);

				if (!!spCityName && !!localityName && spCityName !== 'undefined' && localityName !== 'undefined') {
						$('#formatted_address').val(`${localityName}, ${spCityName}`);
				} else if (!!spCityName && spCityName !== 'undefined') {
						$('#formatted_address').val(spCityName);
				}
		}
		homepageSearchSession = sessionStorage.getItem('homepageSearchSession');
		if (pageVisitType !== 'SEO' && !homepageSearchSession) {

				if (!!searchSessionData) {
						// sessionStorage.setItem('addBoardingLocation', '1');
						if (searchSessionData.formattedAddress) $('#formatted_address').val(searchSessionData.formattedAddress);
						if (searchSessionData.latitude) $('#latitude').val(searchSessionData.latitude);
						if (searchSessionData.longitude) $('#longitude').val(searchSessionData.longitude);
						if (searchSessionData.hasOwnProperty('placeLevel')) $('#place_level').val(searchSessionData.placeLevel);
						if (searchSessionData.hasOwnProperty('city_2_name')) $('#city_2_name').val(searchSessionData.city_2_name);
						if (searchSessionData.hasOwnProperty('city_name')) $('#city_name').val(searchSessionData.city_name);
						if (searchSessionData.hasOwnProperty('state_name')) $('#state_name').val(searchSessionData.state_name);
				}
		}

		if (!!searchSessionData && !homepageSearchSession) {
				if (searchSessionData.hasOwnProperty('searchPlaceLocationData')) {
						if (searchSessionData.searchPlaceLocationData.hasOwnProperty('formatted_address') && searchSessionData.searchPlaceLocationData.formatted_address.length) {
								$('#headerSearchLocationInput').val(searchSessionData.searchPlaceLocationData.formatted_address);
						}
				} else {
						$('#headerSearchLocationInput').val(city_name ? city_name : '');
				}
		}

		if (parseInt(schoolType) === 1 || parseInt(schoolType) === 5) {
				$('#facility-transport').parent().addClass('d-none');
				$('#facility-cctv').parent().addClass('d-none');
				$('#facility-creche').parent().addClass('d-none');
		}

		if (parseInt(schoolType) === 2) {
				/*if (searchParams.hasOwnProperty('is_day_care')) {
						if (!!searchParams.is_day_care) $('#facility-creche').parent().addClass('d-none');
				}*/
				$('#facility-day_boarding').parent().addClass('d-none');
				$('#facility-swimming').parent().addClass('d-none');
		}

		if (parseInt(schoolType) === 3) {
				if (pageVisitType === 'SEARCH') {

						let getCurrentUrl = window.location.href;
						if(getCurrentUrl.includes('sort_by')){
								let sortType= getParameterByName('sort_by', getCurrentUrl);
								let sortInput = $('.sort-filter-wrapper [data-field="' + sortType + '"][data-sorttype="asc"]');
								sortInput.addClass('active');
								$('.main-filter-text').text(sortInput.first().text());
								$('#sort_by').val(sortInput.first().data('field'));
								$('#sort_order').val(sortInput.first().data('sorttype').toUpperCase());
						}else{
								let feeHToLInput = $('.sort-filter-wrapper [data-field="fee"][data-sorttype="desc"]');
								feeHToLInput.addClass('active');
								$('.main-filter-text').text(feeHToLInput.first().text());
								$('#sort_by').val(feeHToLInput.first().data('field'));
								$('#sort_order').val(feeHToLInput.first().data('sorttype').toUpperCase());
						}
				}

				/* hide distance filter in boarding case when city does not exist */
				if(!window.location.href.includes('city')){
					$('.dropdown-item[data-field="distance"]').remove();
				}

		}

		if (parseInt(schoolType) === 1 || parseInt(schoolType) === 2) {
				if (pageVisitType === 'SEARCH') {
						let distanceHToLInput = $('.sort-filter-wrapper [data-field="distance"][data-sorttype="asc"]');
						distanceHToLInput.addClass('active');
						$('.main-filter-text').text(distanceHToLInput.first().text());
						$('#sort_by').val(distanceHToLInput.first().data('field'));
						$('#sort_order').val(distanceHToLInput.first().data('sorttype').toUpperCase());
				}
		}

		// reset counter to 10 where locality exist
		let formattedAddressRangeSlider = $('#formatted_address').val().toLowerCase();
		let city2NameRangeSlider = $('#city_2_name').val().toLowerCase();
		let  cityNameRangeSlider = $('#city_name').val().toLowerCase();
		let stateRangeSlider = $('#state_name').val().toLowerCase();
		let countryRangeSlider = 'india';
		let localityStrFinal = "";

		if(!!formattedAddressRangeSlider){
				localityStrFinal  = getCleanLocality(formattedAddressRangeSlider,cityNameRangeSlider,city2NameRangeSlider,stateRangeSlider)
		}

		if(!!stateRangeSlider){
				if(city_name === 'delhi' && stateRangeSlider !== 'delhi'){
						/* make session variable when have to remove city address from filter */
						sessionStorage.removeItem('addBoardingLocation');
				}
		}

		if(!!localityStrFinal && [1, 5].includes(parseInt(schoolType))){ //for locality
				distanceRangeMax = 10;
		}

		let disableRangeSlider = false;

		/*if(!!searchParamsObj.region_id_arr){
				if(searchParamsObj.region_id_arr.length){
						disableRangeSlider = true;
				}
		}

		if(!!searchParamsObj.state_id_arr){
				if(searchParamsObj.state_id_arr.length){
						disableRangeSlider = true;
				}
		}

		if(!!searchParamsObj.country_id_arr){
				if(searchParamsObj.country_id_arr.length){
						disableRangeSlider = true;
				}
		}*/

		if ($("#distance-range-slider-1").length) {

				const {range_max = {}, range_min = {}} = searchParams;

				let {1: sch_range_max = null} = range_max || {};
				let {1: sch_range_min = null} = range_min || {};
				if (!sch_range_max && !! range_max) {
						let [fetch_sch_range_max = null] = Object.values(range_max) || [];
						sch_range_max = fetch_sch_range_max;
				}
				if (!sch_range_min && !! range_min) {
						let [fetch_sch_range_min = null] = Object.values(range_min) || [];
						sch_range_min = fetch_sch_range_min;
				}
				currentDistanceRangeMax = sch_range_max || 5;
				currentDistanceRangeMin = sch_range_min || currentDistanceRangeMin;

				if(!!searchParams.city_id && [1, 5].includes(parseInt(schoolType))){ // update range slider in case of city id
						currentDistanceRangeMax = sch_range_max || 30;
						distanceRangeSteps = 5;
				}

				if(!!localityStrFinal && [1, 5].includes(parseInt(schoolType))){
						currentDistanceRangeMax = sch_range_max || 5;
						distanceRangeSteps = 1;
				}

				if(!!searchParams.city_id && [2].includes(parseInt(schoolType))){
						currentDistanceRangeMax = sch_range_max || 10;
						distanceRangeSteps = 1;
				}

				if(!!disableRangeSlider){
						currentDistanceRangeMax = distanceRangeMax;
						currentDistanceRangeMin = 0
						$('#filterDistance .filter-options').addClass('disableFilter');
						$('#disableRangeSliderError').remove();
						$('#filterDistance .filter-options').append('<small id="disableRangeSliderError">You can use this filter only in city or locality.</small>');
				}

				$("#distance-range-slider-1").ionRangeSlider({
						type: "double",
						min: 0,
						max: distanceRangeMax,
						from: currentDistanceRangeMin,
						to: currentDistanceRangeMax,
						step: distanceRangeSteps,
						onStart: updateDistanceRangeSliderDataOnInput,
						onChange: updateDistanceRangeSliderDataOnInput,
						onUpdate: function(data){
							if(data.to === 0) return false;

							updateAppliedFilters(true);
							resetPageData();
							seoViewMore(pageVisitType, viewMoreURL);
							ajaxSearch();
							updateDistanceRangeSliderDataOnInput(data);
							updateAppliedFilters(true);

							/* scroll top page on search page */
							if (pageType === 'SEARCH') $('html, body').animate({scrollTop: $('#school-tile-container').offset().top - 200}, 800);
							/* scroll top page on search page */

							//store session data for heading
							sessionStorage.setItem('updateRangeSliderHeading', '1');
						},
						onFinish: function (data) {

								if(data.to === 0) return false;

								resetPageData();
								seoViewMore(pageVisitType, viewMoreURL);
								ajaxSearch();
								updateDistanceRangeSliderDataOnInput(data);
								updateAppliedFilters(true);

								/* scroll top page on search page */
								if (pageType === 'SEARCH') $('html, body').animate({scrollTop: $('#school-tile-container').offset().top - 200}, 800);
								/* scroll top page on search page */

								//store session data for heading
								sessionStorage.setItem('updateRangeSliderHeading', '1');
						}
				});
		}

		updateHeadingRangeSlider(currentDistanceRangeMin, currentDistanceRangeMax);

		/*-----------------open first filter-------------*/
		openFirstFilter();
		/*-----------------/open first filter-------------*/

		updateAppliedFilters();

		/**
		 * Update search boarding heading
		 */
		/*if(!window.location.href.includes('city_name') && !window.location.href.includes('state_name') && (parseInt(schoolType) === 3) && (pageVisitType === 'SEARCH') && !window.location.href.includes('region')){
			$('.search_heading').text('Boarding School List in India');
		}*/

}

function updateAppliedFilters(rangeSlider = false){

	const filters = $('.filter-container-wrapper-body input:checked');
	const appliedFilterContainer = $('#appliedFilterContainer');
	const appliedFilterBadge = $('#appliedFilterBadge');
	let counter = 0;

	const {range_max = {}, range_min = {}} = searchParams;

	let {1: sch_range_max = null} = range_max || {};
	let {1: sch_range_min = null} = range_min || {};
	if (!sch_range_max && !! range_max) {
		let [fetch_sch_range_max = null] = Object.values(range_max) || [];
		sch_range_max = fetch_sch_range_max;
	}
	if (!sch_range_min && !! range_min) {
		let [fetch_sch_range_min = null] = Object.values(range_min) || [];
		sch_range_min = fetch_sch_range_min;
	}

	if(filters.length || ( schoolType!== 3 && !!sch_range_max)){
		const appliedFiltersWrapper = $('#appliedFiltersWrapper');
		let filterStr = '';

		if(filters.length){

			filters.each((i, input) => {
				counter++;
				const selector = $(input);
				filterStr+=`<span class="toggle-filter d-inline-block" data-id="${selector.val()}">${selector.next().text()} <i class="pl-2 fa fa-times text-red" aria-hidden="true"></i></span>`;
			});

		}

		// filterStr += addRangeFilterTag(sch_range_min, sch_range_max, rangeSlider);

		if(filterStr.length) {
			appliedFiltersWrapper.empty().html(filterStr);
			appliedFilterContainer.removeClass('d-none');
			addUpdateFilterEvents(); // toggle filter

			if(appliedFilterBadge.length) appliedFilterBadge.text(counter).removeClass('d-none');

		}else{
			appliedFiltersWrapper.empty();
			appliedFilterContainer.addClass('d-none');
			if(appliedFilterBadge.length) appliedFilterBadge.addClass('d-none');
		}

	}else{
		appliedFilterContainer.addClass('d-none');
	}

}

function addRangeFilterTag(min = 0, max = 0, rangeSlider = false){
	if(min === null || max === null) return '';
	const defaultRangeMax = defaultRangeForTag[schoolType];
	let filterStr = '';

	if(rangeSlider){

		const currentRange = $("#distance-range-slider-1").data("ionRangeSlider");

		min = currentRange.result.from;
		max = currentRange.result.to;

	}

	if(schoolType !== 3){
		if(max){
			if((defaultRangeMax == max) && (min == 0)){
				filterStr+='';
			}else{
				filterStr+=`<span class="toggle-filter d-inline-block" data-id="rangeSlider">${min} - ${max} KM <i class="pl-2 fa fa-times text-red" aria-hidden="true"></i></span>`;
			}
		}
	}
	return filterStr;
}

function addUpdateFilterEvents(){

	$("#appliedFiltersWrapper .toggle-filter").on('click', function (e) {
		e.preventDefault();
		let filterType = $(this).data('id');

		if(filterType.indexOf('board') >= 0 ||
			filterType.indexOf('region') >= 0 ||
			filterType.indexOf('facility') >= 0) $(`#${filterType}`).trigger('click');

		if(filterType.indexOf('fee') >= 0 ||
			filterType.indexOf('pg_school') >= 0 ||
			filterType.indexOf('coed') >= 0) $(`[value="${filterType}"]`).trigger('click');

		if(schoolType != 3){

			if(filterType.indexOf('rangeSlider') >= 0){

				console.log('reset range Slider');
				const currentRange = $("#distance-range-slider-1").data("ionRangeSlider");
				const defaultRangeMax = defaultRangeForTag[schoolType];
				currentRange.update({
					from: 0,
					to: defaultRangeMax
				});

			}

		}

	});

}


function seoViewMore(pageVisitType, ViewMoreUrl, removedTag = "") {
		if (pageVisitType === 'SEO' || pageVisitType === 'DEDICATED_SEARCH_PAGE') {
				if (removedTag) updateURL = ViewMoreUrl.replace(removedTag, '');
				else getFilterParams(pageVisitType, ViewMoreUrl);
				window.location.href = updateURL;
		}
		return false;
}

function insertSearchFilterHistory(filterMain, post_tags) {
		// Insert Search History Code
		let school_type_text = getSchoolTypeName(schoolType);

		let formatted_address = filterMain.filter(function (obj) {
				return obj.formatted_address;
		}).map(function (obj) {
				return obj.formatted_address;
		});

		let searchPageName = (typeof (pageType) != "undefined") ? pageType : window.location.href;
		let SearchFilter = post_tags.join(',');
		let SearchText = school_type_text + ' in ' + slugify(formatted_address.join());
		if (SearchText.split(' ')[2].length === 0) SearchText = '';
		let cityText = filterMain.filter(obj => obj.city_2_name).map(obj => obj.city_2_name);
		let place_lat = filterMain.filter(obj => obj.city_latitude).map(obj => obj.city_latitude);
		let place_lng = filterMain.filter(obj => obj.city_longitude).map(obj => obj.city_longitude);

		let InsertSearchParameter = {
				'page': searchPageName,
				'city': cityText.join(),
				'filter': SearchFilter,
				'filter_text': SearchText,
				'type_id': schoolType,
				'location_short': cityText.join(),
				'location_long': formatted_address.join(),
				'lat': place_lat.join(),
				'long': place_lng.join(),
		};
		InsertSearchApi(InsertSearchParameter);
}


function getFilterParams(pageVisitType = false, viewMoreURL = '') {
		let addBoardingLocation = sessionStorage.getItem('addBoardingLocation');
		let checkRangeMax = sessionStorage.getItem('addRangeMax');
		let post_tags_str;
		let post_tags = [];
		let post_tags_ = [];
		let level = 0;
		let filter = [];
		let board = [];
		let region = [];
		let coed = [];
		let path = '';
		let url;
		let stateQueryParam = '';

		let AllQueryParams = (new URL(document.location)).searchParams;

		let place_level = $("#place_level").val();

		url = (pageVisitType === 'SEO') ? viewMoreURL : document.URL;

		let params = getParams(url);

		// let city_name = $('#city_name').val() ? $('#city_name').val() : ipCityName;
		let city_name = $('#city_name').val();

		if (!!city_name) {
				city_name = city_name.split(" ").join("-").toLowerCase()
		}
		let city_2_name = $("#city_2_name").val();
		if (!!city_2_name) {
				if (city_2_name.length) {
						city_2_name = city_2_name.split(" ").join("-").toLowerCase();
				}
		}

		let stateText = $('#state_name').val();

		if (!city_name && !city_2_name && !!stateText) stateQueryParam = 'state_name=' + stateText.toLowerCase().split(' ').join('-');

		if(!addBoardingLocation && (city_name !== stateText.toLowerCase) && !!stateText){
				stateQueryParam = 'state_name=' + stateText.toLowerCase().split(' ').join('-');
		}

		let range_min = 0;
		let range_max = 0;

		if ($("#distance-range-slider-1").length) {
				let displayRangeSliderInput = $("#distance-range-slider-1");
				range_max = displayRangeSliderInput.attr('data-to');
				range_min = displayRangeSliderInput.attr('data-from');
		}

		range_max = typeof range_max !== 'undefined' ? range_max : 5;

		// updateHeadingRangeSlider(range_min, range_max);

		level = (place_level === "administrative_area_level_1") ? 1 : level;

		$.each(params, function (index, value) {
				if (index === 'place_level') if (value === "administrative_area_level_1") level = 1;
		});


		$('.filter-container input:checked').each(function () {
				let tag = $(this).val();
				post_tags.push(tag);

				if (tag.indexOf('board') === 0) {
						let label = $(this).next().text().toLowerCase().replaceAll(' ', '').replace('&', '-');
						// let board_id = tag.split("-")[1];
						// board.push(getBoardName(board_id));
						board.push(label);
				} else if (tag.indexOf('region') === 0) {
						let region_id = tag.split("-")[1];
						region.push(getRegionName(region_id));
				} else if (tag.indexOf('coed') === 0) {
						let coed_id = tag.split("-")[1];
						coed.push(getCoedTypeName(coed_id));
				} else post_tags_ += '&Tags[]=' + tag;

				all_tags.push(tag);

		});

		if (post_tags_.length > 0) post_tags_ = (post_tags_.indexOf('&') === 0) ? post_tags_.substring(1) : post_tags_;

		if (coed.length) path += coed.join("-and-");
		if (board.length > 0) path += ((coed.length) ? '-' : '') + board.join("-and-") + "-schools";
		if (region.length > 0) path += ((coed.length || board.length) ? board.length === 0 ? '-schools-in-' : '-in-' : board.length === 0 ? 'schools-in-' : '') + region.join("-and-") + "-region";

		let pageVisitLatitude = $("#latitude").val();
		let pageVisitLongitude = $("#longitude").val();
		let response = {};

		if ((!!pageVisitLatitude && !!pageVisitLongitude) &&
				(pageVisitLatitude.indexOf('undefined') === -1) &&
				(pageVisitLongitude.indexOf('undefined') === -1)) {
				response = encode_decode({
						latitude: pageVisitLatitude ? pageVisitLatitude : latitude,
						longitude: pageVisitLongitude ? pageVisitLongitude : longitude
				});
		}
		let type = getSchoolTypeName(schoolType);

		let formatted_address = $("#formatted_address").val();
		if ($("#formatted_address").val().length) {
				formatted_address = formatted_address.toLowerCase().split(" ").join("-").split(",").join("-").split("--").join("-");
		}

		let address = formatted_address;
		if ($("#formatted_address").val().length) {
				address = formatted_address + `${$.isEmptyObject(response) ? '' : `-${response.data.latlng}`}` + '/';
		}

		if (!address && !!city_name) {
				address = city_name + `${$.isEmptyObject(response) ? '' : `-${response.data.latlng}`}` + '/';
		}

		path = (path.length > 0) ? (address.indexOf('undfined') >= 0 ? '/' : '') + path : "";

		let city2QueryParam = '';
		let cityQueryParam = '';
		if ((city_name !== city_2_name) && !!city_2_name) city2QueryParam = city_2_name.length ? `city_2_name=${city_2_name}` : '';
		if (!!city_name) cityQueryParam = city_name.length !== 0 ? `city_name=${city_name}` : '';
		let queryParams = [];

		/*remove location when not coming from header search with location*/
		// if (!addBoardingLocation && (parseInt(schoolType) === 3)) {
		if (!addBoardingLocation) {
				city2QueryParam = "";
				cityQueryParam = "";
				// stateQueryParam = "";
		}

		let placeLevel = $('#place_level').val();
		placeLevelQueryParam = '';
		if(!!placeLevel) placeLevelQueryParam = `place_level=${placeLevel}`;

		let locality = $('#locality').val();
		localityQueryParam = '';
		if(!!locality) localityQueryParam = `locality=${locality}`;

		if (region.length === 0) {
				if (stateQueryParam.length) queryParams.push(stateQueryParam);
				if (city2QueryParam.length) queryParams.push(city2QueryParam);
				if (cityQueryParam.length) queryParams.push(cityQueryParam);
				if (localityQueryParam.length) queryParams.push(localityQueryParam);
				if (placeLevelQueryParam.length) queryParams.push(placeLevelQueryParam);
		}

		if (post_tags_.length) queryParams.push(post_tags_);
		queryParams = queryParams.join('&')

		const lang = Cookies.get('preferred_language');
		const languageParam = (lang && location.pathname.includes(`/${lang}/`)) ? `/${lang}` : "";

		if (address.indexOf('undefined') >= 0) address = '';
		if (region.length) address = "";

		let rangeMinMaxQueryString = '';
		if (!!range_max) {
				rangeMinMaxQueryString = `&range_min=${range_min}&range_max=${range_max}`
		}

		/*remove location when not coming from header search with location*/
		if (!addBoardingLocation && (parseInt(schoolType) === 3)) address = "";

		if((place_level === 'locality') && (parseInt(schoolType) === 3) && region.length === 0 && !stateQueryParam){
				rangeMinMaxQueryString = `&range_max=100&sort_by=distance`
		}

		if((place_level !== 'locality') &&  !!checkRangeMax && region.length === 0 && !stateQueryParam && (parseInt(schoolType) === 3)){
				rangeMinMaxQueryString = `&range_max=${checkRangeMax}`;
		}

		if((pageType === 'SEO') && region.length === 0 && !stateQueryParam && (parseInt(schoolType) === 3)){
				if($('.loadMoreBtn').length){
						let getLoadMoreUrl = $('.loadMoreBtn').attr('href');
						if(getLoadMoreUrl.includes('range_max')){
								let getRangeMax = getParameterByName('range_max', getLoadMoreUrl);
								if(!!getRangeMax) rangeMinMaxQueryString = `&range_max=${getRangeMax}`
						}
				}
		}


		if ([1, 2, 5].includes(parseInt(schoolType))) {
				// updateURL = `${languageParam}/search/${type}/${formatted_address ? formatted_address + '-' : ''}${response.data.latlng}${path ? '/' + path : ''}/?place_level=${place_level}&city_name=` + city_name.toLowerCase().split(" ").join("-").split(",").join("-").split("--").join("-") + "&range_max=" + range_max + "&range_min=" + range_min + "&" + post_tags_.toString().replace("?", "");
				updateURL = `${languageParam}/search/${type}/${address}${path}${queryParams ? `?${queryParams}` : ''}${rangeMinMaxQueryString ? `${!queryParams ? '?' : ''}` + `${rangeMinMaxQueryString}` : ''}`;
		} else if ([3, 4].includes(parseInt(schoolType))) {
				updateURL = `${languageParam}/search/boarding-school/${address}${path}${queryParams ? `?${queryParams}` : ''}${rangeMinMaxQueryString ? `${!queryParams ? '?' : ''}` + `${rangeMinMaxQueryString}` : ''}`;/*	remove address if region filter select	*/
		}

		if (DEBUG) console.log(pageVisitType, 'pageVisitType', typeof pageVisitType);

		if ((pageVisitType === 'DEDICATED_SEARCH_PAGE') || (pageVisitType === 'SEO')) {
				window.location = window.location.origin + updateURL;
				return false;
		}

		let cityLat = pageVisitLatitude ? pageVisitLatitude : latitude;
		let cityLng = pageVisitLongitude ? pageVisitLongitude : longitude;

		/* -----------------------------removing lat & lng in india case------------------------------------ */
		/* -----------------------------removing lat & lng in india case------------------------------------ */

		let filterFormData = new FormData();
		if (region.length > 0) { //Making lat long null when region filter apply
				cityLat = null;
				cityLng = null;
				filter.push({city_latitude: null});
				filter.push({city_longitude: null});
				filter.push({city_name: null});
				filter.push({city_2_name: null});
				filter.push({place_level: null});
				filter.push({locality: null})
				filter.push({state_name: null})
		} else {				/* for search insert history */
				if (cityLat) filter.push({city_latitude: cityLat});
				if (cityLng) filter.push({city_longitude: cityLng});
				if (city_name) filter.push({city_name: city_name});
				if ($("#formatted_address").val()) filter.push({formatted_address: $("#formatted_address").val()});
				if (($("#city_2_name").val() !== city_name) && $("#city_2_name").val()) filter.push({city_2_name: $("#city_2_name").val()});
				if ($("#place_level").val()) filter.push({place_level: $("#place_level").val()});
				if(!!searchParamsObj.locality) {
						if(!!searchParamsObj.locality) filter.push({locality: searchParamsObj.locality})
				}
				/* for search insert history */
		}

		/* for search insert history */
		if (schoolType) filter.push({school_type: schoolType});
		if ($("#sort_by").val()) filter.push({sort_by: $("#sort_by").val()});
		if ($("#sort_order").val()) filter.push({sort_order: $("#sort_order").val()});
		if (!city_name && !city_2_name && stateText && (region.length === 0)) filter.push({state_name: stateText});

		//send state name in filter when state query
		if(!addBoardingLocation && (city_name !== stateText.toLowerCase)){
				let checkForStateName = filter.filter((v, i) => {
						if (v.hasOwnProperty('state_name')){
								return true;
						}else{
								return false;
						}
				});
				if(!checkForStateName.length && (region.length === 0)) filter.push({state_name: stateText});
		}

		if (range_min) filter.push({distance_min: range_min});
		if (range_max) filter.push({distance_max: range_max});		/* for search insert history)*/
		if (getSearchParams('list')) filter.push({list: "city"});
		try {
				post_tags_str = JSON.stringify(post_tags);
		} catch (e) {
				post_tags_str = '';
		}

		localStorage.removeItem('tags');
		localStorage.setItem('tags', post_tags_str);

		/*remove location when not coming from header search with location*/
		// if (!addBoardingLocation && (parseInt(schoolType) === 3)) {
		if (!addBoardingLocation) {
				filter = filter.filter((v, i) => {
						if (v.hasOwnProperty('city_latitude') ||
								v.hasOwnProperty('city_longitude') ||
								v.hasOwnProperty('city_name') ||
								v.hasOwnProperty('city_2_name') ||
								v.hasOwnProperty('place_level')
						) {
								return false;
						} else {
								return v;
						}
				});
				cityLat = "";
				cityLng = "";
		}

		if((place_level === 'locality') && (parseInt(schoolType) === 3) && region.length === 0 && !stateQueryParam){
				filter.push({distance_max: 100});
		}

		if((place_level !== 'locality') &&  !!checkRangeMax && region.length === 0 && !stateQueryParam && (parseInt(schoolType) === 3)) {
				if (!!checkRangeMax) filter.push({distance_max: checkRangeMax});
		}

		/* =======================add filter form params object ======================== */
		if(region.length === 0){
				if(!!searchParamsObj.administrative_area_level_1) filter.push({'administrative_area_level_1': searchParamsObj.administrative_area_level_1});
				if(!!searchParamsObj.administrative_area_level_2) filter.push({'administrative_area_level_2': searchParamsObj.administrative_area_level_2});
				if(!!searchParamsObj.administrative_area_level_3) filter.push({'administrative_area_level_3': searchParamsObj.administrative_area_level_3});
				if(!!searchParamsObj.archipelago) filter.push({'archipelago': searchParamsObj.archipelago});
				if(!!searchParamsObj.colloquial_area) filter.push({'colloquial_area': searchParamsObj.colloquial_area});
				if(!!searchParamsObj.country) filter.push({'country': searchParamsObj.country});
				if(!!searchParamsObj.establishment) filter.push({'establishment': searchParamsObj.establishment});
				if(!!searchParamsObj.floor) filter.push({'floor': searchParamsObj.floor});
				if(!!searchParamsObj.intersection) filter.push({'intersection': searchParamsObj.intersection});
				if(!!searchParamsObj.landmark) filter.push({'landmark': searchParamsObj.landmark});
				if(!!searchParamsObj.locality) filter.push({'locality': searchParamsObj.locality});
				if(!!searchParamsObj.natural_feature) filter.push({'natural_feature': searchParamsObj.natural_feature});
				if(!!searchParamsObj.neighborhood) filter.push({'neighborhood': searchParamsObj.neighborhood});
				if(!!searchParamsObj.plus_code) filter.push({'plus_code': searchParamsObj.plus_code});
				if(!!searchParamsObj.point_of_interest) filter.push({'point_of_interest': searchParamsObj.point_of_interest});
				if(!!searchParamsObj.political) filter.push({'political': searchParamsObj.political});
				if(!!searchParamsObj.post_box) filter.push({'post_box': searchParamsObj.post_box});
				if(!!searchParamsObj.postal_code) filter.push({'postal_code': searchParamsObj.postal_code});
				if(!!searchParamsObj.premise) filter.push({'premise': searchParamsObj.premise});
				if(!!searchParamsObj.route) filter.push({'route': searchParamsObj.route});
				if(!!searchParamsObj.street_number) filter.push({'street_number': searchParamsObj.street_number});
				if(!!searchParamsObj.sublocality) filter.push({'sublocality': searchParamsObj.sublocality});
				if(!!searchParamsObj.sublocality_level_1) filter.push({'sublocality_level_1': searchParamsObj.sublocality_level_1});
				if(!!searchParamsObj.sublocality_level_2) filter.push({'sublocality_level_2': searchParamsObj.sublocality_level_2});
				if(!!searchParamsObj.sublocality_level_3) filter.push({'sublocality_level_3': searchParamsObj.sublocality_level_3});
				if(!!searchParamsObj.subpremise) filter.push({'subpremise': searchParamsObj.subpremise});
				if(!!searchParamsObj.town_square) filter.push({'town_square': searchParamsObj.town_square});
		}
		/* =======================/add filter form params object ======================== */

		return {
				Tags: post_tags,
				Filters: filter,
				city_lat: cityLat,
				city_lng: cityLng,
				page_type: pageVisitTypeForFilter,
				updateURL: updateURL
		};
}

/*
* Returns a map of querystring parameters
*
* Keys of type <fieldName>[] will automatically be added to an array
*
* @param String url
* @return Object parameters
*/

function getParams(currentUrl) {
		// if(DEBUG) console.log(currentUrl);
		let regex = /([^=&?]+)=([^&#]*)/g, params = {}, parts, key, value;

		while ((parts = regex.exec(currentUrl)) != null) {

				key = parts[1];
				value = parts[2];
				const isArray = /[\[\]]/gmi.test(key);

				if (isArray) {
						params[key] = params[key] || [];
						params[key].push(value);
				} else {
						params[key] = value;
				}
		}

		return params;
}

/*function encode_decode(params = {}) {
		let formatObj;
		// console.log({params});
		if (params['latitude'] && params['latitude'] !== "" && params['longitude'] && params['longitude'] !== "") {
				let latLngStr = params['latitude'] + ',' + params['longitude'];
				formatObj = {data: {'latlng': window.btoa(latLngStr)}, 'error': ''};
		} else formatObj = {data: {}, error: 'Error!!'};

		return formatObj;
}*/

function getSearchParams(k) {
		let p = {};
		location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, (s, k, v) => p[k] = v);
		return k ? p[k] : p;
}

/*function getSchoolTypeName($schoolType) {
		$schoolType = parseInt($schoolType);

		switch ($schoolType) {
				case  1 :
						return 'day-school';
				case 2 :
						return 'pre-school';
				case 3 :
						return 'boarding-school';
				case 5:
						return 'pu-junior-colleges';
				case 4:
						return 'day-care';
				case 6:
						return 'online-school';
		}
}*/

function InsertSearchApi(SearchParameter) {

		$.post(`${HOST}/searches/index.php?action=insert`, SearchParameter)
				.done(() => DEBUG ? console.log('Recent Searches Successfully added') : 1)
				.fail(error => DEBUG ? console.log({error}) : 1);
}


function bind_search_input_address(searched_address_string) {
		if ($('#show_search_string').val()) {
				$('#MobHeaderSearchInput').attr('value', searched_address_string);
				$('#DeskHeaderSearchInput').attr('value', searched_address_string);
		} else {
				$('#MobHeaderSearchInput').attr('value', '');
				$('#DeskHeaderSearchInput').attr('value', '');
		}
}


function SeoViewMore(pageVisitType, ViewMoreUrl, removedTag = "") {
		if (['SEO', 'DEDICATED_SEARCH_PAGE'].includes(pageVisitType)) {
				// show_loaders();
				if (removedTag) updateURL = ViewMoreUrl.replace(removedTag, '');
				else getFilterParams(pageVisitType, ViewMoreUrl);
				window.location.href = updateURL;
		}
		return false;
}

/*function getCoedTypeName(id) {

		let coed = "";
		switch (id) {
				case "1":
						coed = "coed";
						break;
				case "2":
						coed = "girls";
						break;
				case "3":
						coed = "boys";
						break;
		}
		return coed;
}*/

/*function getBoardName(id) {

		let board = "";
		switch (id) {
				case "1":
						board = "cbse";
						break;
				case "2":
						board = "icse-isc";
						break;
				case "3":
						board = "ib";
						break;
				case "4":
						board = "Others";
						break;
				case "6":
						board = "igcse";
						break;
		}

		return board;
}*/

/*function getRegionName(id) {

		let region = "";
		switch (id) {
				case "1":
						region = "north";
						break;
				case "2":
						region = "east";
						break;
				case "3":
						region = "south";
						break;
				case "4":
						region = "west";
						break;
				case "5":
						region = "central";
						break;
		}

		return region;
}*/

function generateImpressionEA(data) {
		let schools = [];
		_.forEach(data, function (obj) {
				schools.push({id: (obj && obj.hasOwnProperty('id')) ? obj.id : null, type_id: schoolType});
		});
		schools = _.filter(schools, (obj => obj.id));
		$.post(`${HOST}/common/routes/ajax_init_school_impression.php`, {schools: schools})
				.done(res => DEBUG ? console.log(res) : 1)
				.fail(error => DEBUG ? console.log(error) : 1)
}

const show_loaders = () => {
		$('.loading-bar').show();
};

const hide_loaders = () => {
		$('.loading-bar').hide();
};

const getFormattedFees = (school) => {
		let {fees = null, yearly_fees2 = null} = school;
		const {school_type_id = "1"} = searchParamsObj;
		let feesText = fees;

		if (parseInt(school_type_id) === 2 && !!fees) {
				fees = Math.ceil(fees / 12);
				feesText = parseFloat(parseInt(fees).toFixed(2));
		}

		if ([3, 4].includes(parseInt(school_type_id)) && !!yearly_fees2) feesText = yearly_fees2;

		feesText = indianPriceFormat(feesText);
		if (([3, 4].includes(parseInt(school_type_id)) && !yearly_fees2)) feesText = null;
		return feesText ? `₹${feesText}` : "N/A";
}

const getBoardText = (board1, board2, board3) => {
		let Board = [board1, board2, board3];
		Board = Board.filter(Boolean).join(", ");
		return Board;
};

const getAddressText = (address1, city, state) => {
		let string;
		if (schoolType === '3') string = (city !== state) ? city + ',' + state : city; // for boarding case show only city and state
		else string = address1; // for other cases show address1
		if (string !== '' && string != null) return string.replace("?", "", string);
		else return string;
};

const getEstablishmentYear = (year) => {
		return (!!parseInt(year)) ? year : "N/A";
};

const formatPhoneNo = (number) => {
		if (number === '' || number == null) return '';
		else number = number.toString();

		if (number.substring(0, 1) === '0') return `+91-${number.substring(1, number.length)}`;
		else if (number.substring(0, 2) === '91' && number.length > 11) return `+91-${number.substring(2, number.length)}`;
		else if (number.substring(0, 3) === '+91') return number;
		else return `+91-${number}`;
};

const checkVadPhone = (subscription_status, vad) => {
		let vadPhone = '';
		if (subscription_status && vad === 1) vadPhone = "+919811247700";
		return vadPhone;
};

const FinalPhoneNumber = (status, vad, phone1) => {
		let phone = checkVadPhone(status, vad);
		return (phone === '') ? phone1 : phone;
};

const getYearOrMonth = (schoolType) => {
		let text = '';
		if ([1, 3, 4, 5].includes(schoolType)) text = "/ Year";
		else if (schoolType === 2) text = "/ Month";
		return text;
};

const getFlag = (flag) => {
		let fgv = "Yes";
		if (flag === 0) fgv = "No";
		else if (flag === 2) fgv = "NA";
		return fgv;
};

const getDistance = (distance) => {
		if (distance === null) this.parent().hide();
		else {
				distance = parseFloat(distance);
				distance = parseFloat(distance.toFixed(1));
		}
		return distance;
};

const callSchoolClickBind = () => {
		$('.call_school').on('click', function (e) {
				e.stopPropagation();
		});
};

const AdmissionOpenButtonClickBind = () => {
		$('button.apply-admission-search').on('click', function (e) {
				e.stopPropagation();
		});
};
const cwsButtonClickBind = () => {
		$('button.apply-vad-search').on('click', function (e) {
				e.stopPropagation();
		});
};

const arrayToObject = (arr) => {
		let result = {};
		for (let i = 0; i < arr.length; i++) {
				result[arr[i].key] = arr[i].value;
		}
		return result
};


const SearchTitleUpdate = (params, pageVisitType, title_location_string) => {

		if (pageVisitType !== 'SEO') {
				let school_type = getSchoolTypeById(params.type_id);
				let text;
				if (params.otherparam && params.otherparam.place_level === "administrative_area_level_1") {
						text = `${school_type} in ${(params.google_map_address) ? params.google_map_address : ''}`;
				} else if (parseInt(params.type_id) !== 3 && parseInt(params.type_id) !== 6) {
						text = title_location_string ? `${school_type} within ${(parseInt(params.range_min))}-${(parseInt(params.range_max))} kms. from ${title_location_string}`
								: `${school_type} within ${(parseInt(params.range_min))}-${(parseInt(params.range_max))} kms. from ${(params.google_map_address) ? params.google_map_address : ''}`;
				} else text = `${((parseInt(params.type_id) === 3) || (parseInt(params.type_id) === 4)) ? 'Boarding School' : school_type} List`;

				$('.sorting-header').html(`<h1 class="sorting-title text-capitalize search_heading">${text}</h1> <p class="sorting-lead" id="schoolCount"> </p>`);

		}
};



function resetPageData() {
		jsonSearchData = [];
		page = 1;
		schoolTotalCount = 0;
}

function openSchoolInNewTab(url, event) {
		if ($(event).hasClass('blur-container')) {
				if (!user) {
						loginBlurAnalytics();
						$('#loginModal').modal('show');
				}
				return false;
		}
		window.open(url);
}

function addBlurProperty() {
		let blurLoginScroll = true;
		let schoolCardsWrapper = $('#school-tile-container .all-school-wrapper');

		if (!user) {
				let childLength = schoolCardsWrapper.children().length;
				if (childLength >= 30) {
						$('#blurLoginEffect').show();
						schoolCardsWrapper.find('.school-details-wrapper:nth-last-of-type(1)').addClass('blur-container');
						schoolCardsWrapper.find('.school-details-wrapper:nth-last-of-type(2)').addClass('blur-container');
						blurLoginScroll = false;
				}
		}
		return blurLoginScroll;
}

function blurLoginEffectHTML() {
		$('#blurLoginEffect').empty();
		let totalCount = parseInt($('#schoolCount .result-found').text());
		let totalLeftSchools = totalCount - 28;

		let blurHtml = `<div class="blur-login-modal mt-3" onclick="loginBlurAnalytics();$('#loginModal').modal('show');">										
												${totalLeftSchools > 0 ? `<span class="more-results mb-2 d-block text-center text-red font-weight-bold" 
																										id="schoolsListCountBlur">${--totalLeftSchools}+ more results</span>` : ``}										
												<span class="login-text d-block text-center">Login to view all schools</span>
												<a href="#" class="blur-login-btn">
															<img data-src="${HOST}/assets/icons/login-alert.svg"
														 	class="login-image-blur lazyload" alt="Unlock Now"/>Unlock Now</a>
										</div>`;

		if(totalCount < 30) blurHtml = '';

		$('#blurLoginEffect').html(blurHtml);
}



function BlurHtmlOnScroll() {
		if (mobileCheck()) {
				if ($('#school-tile-container').children().hasClass('blur-list')) {
						let blurList = $('.blur-list').isInViewport();
						if (blurList) {
								let blurListPercent = $('.blur-list').viewPortPercentage();
								if (blurListPercent < 25 || blurListPercent > 93) {
										$('.blur-login-modal').hide();
								} else {
										$('.blur-login-modal').show();
								}
						} else {
								$('.blur-login-modal').hide();
						}
				}
		}
}

function loginBlurAnalytics() {
	gtag('event', {
		event_category: 'Login/Signup',
		event_action: 'Search Login Click',
		event_label: 'Search Login Click'
	});
}

function time_convert(num) {
		const hours = Math.floor(num / 60);
		const minutes = num % 60;
		return `${hours} Hour(s) ${minutes} Min`;
}

const cfs_trigger = (label) => {
		gtag( {
				hitType: 'event',
				event_category: 'Contacted From School - Clicked.',
				event_action: 'Click',
				event_label: label
		});
};

const SchoolCountUpdate = (SchoolCount) => {
		$('#schoolCount').html(`<span class="result-found">${SchoolCount} Result(s) found </span>`);
};

function getSchoolCardUI(school) {
		let parentRating = 0;
		if (school.parent_rating) parentRating = school.parent_rating.avgRating;
		let rateCount = school.parent_rating.rateCount;
		let boards = getBoardText(school.board_1_txt, school.board_2_txt, school.board_3_txt);
		// let schoolImage = (school.imgpthm).replace(/\s+/g, '').trim();
		let schoolImage = school.imgpthm;
		let feesText = school.fees_text ? (school.fees_text).split(' / ') : '';
		// let feesType = feesText.length ? feesText[1] : '';
		let feesType = parseInt(school.typeid) === 2 ? 'Monthly' : 'Annual';
		let feesTypeWeb = parseInt(school.typeid) === 2 ? '/ month' : '/ annum';
		let feesAmount = feesText.length ? feesText[0] : '';
		let schoolGrades = '';

		let schoolImageAltTextArray = [];
		schoolImageAltTextArray.push(school.name,school.city,school.locality,school.address1,school.board_1_txt,school.board_2_txt,school.board_3_txt)
		schoolImageAltTextArray = schoolImageAltTextArray.filter((value) => {
			if(!!value) return value;
		});

		// console.log(schoolImageAltTextArray, 'schoolImageAltTextArray', schoolImageAltTextArray.join(', '));

		if (!!school.grade_from_txt) {
				schoolGrades = `${school.grade_from_txt}`;
				if (!!school.grade_to_txt) {
						schoolGrades += ` - ${(school.grade_to_txt).replace('Class', '')}`;
				}
		}

		if ([3, 4].includes(parseInt(schoolType))) {
				if (!!school.residential_grade_from_txt) {
						schoolGrades = `${school.residential_grade_from_txt}`;
						if (!!school.residential_grade_to_txt) {
								schoolGrades += ` - ${(school.residential_grade_to_txt).replace('Class', '')}`;
						}
				}
		}

		let schoolFeatures = '';

		let schoolPhoneNumber = '';
		if (!!school.subscription_status) {
				schoolPhoneNumber = "+919811247700";
		}

		let schoolAddress = school.address;
		if ([3, 4].includes(parseInt(schoolType))) {
				schoolAddress = school.city_name;
				if (!!schoolAddress) {
						if (!!school.state_name) {
								schoolAddress += `, ${school.state_name}`;
						}
				}
		}

		if (parseInt(school.typeid) !== 2) {
				schoolFeatures = `<div class="d-flex flex-column feature-wrapper">
												<span>Board</span>
												<span class="font-weight-bold">${boards ? boards : 'N/A'}</span>
											</div>
											<div class="d-flex flex-column feature-wrapper">
												<span>Gender</span>
												<span class="font-weight-bold">${school.coedtype ? school.coedtype.replace(/only/gi, '').trim() : 'N/A'}</span>
											</div>
											<div class="d-flex flex-column feature-wrapper">
												<span>Grade</span>
												<span class="font-weight-bold">${!!schoolGrades ? schoolGrades : 'N/A'}</span>
											</div>
											`
		} else {
				schoolFeatures = `<div class="d-flex flex-column feature-wrapper">
												<span>Min Age</span>
												<span class="font-weight-bold">${school.minage.length ? school.minage : 'N/A'}</span>
											</div>
											<div class="d-flex flex-column feature-wrapper">
												<span>Day Care</span>
												<span class="font-weight-bold">${school.creche ? 'Yes' : 'N/A'}</span>
											</div>
											<div class="d-flex flex-column feature-wrapper">
												<span>AC Classroom</span>
												<span class="font-weight-bold">${!!school.hasac ? 'Yes' : 'N/A'}</span>
											</div>
											<div class="d-flex flex-column feature-wrapper">
												<span>CCTV</span>
												<span class="font-weight-bold">${!!school.cctv ? 'Yes' : 'N/A'}</span>
											</div>`;
		}

		return `<div class="col-12 school-details-wrapper cursor-pointer edu-${school.id}" onclick="openUrlInNewTab('${school.final_url}')">
					<div class="school-card-wrapper position-relative" id="school_${school.id}">
  						<div class="d-flex school-card-container">
								<div class="img-btn-wrapper w-100 position-relative">
										<img
										src="${schoolImage}"
										class="w-100 h-100"
										loading="lazy"
										title="${school.name}>" alt="${schoolImageAltTextArray.join(', ')}">
									${school.distance && !isMobileView ? `<span class="distance-near-by position-absolute text-truncate text-white d-block">${school.distance + ' KM'}</span>` : ''}
									<span class="d-block position-absolute text-white viewed-by text-center"><i class="fa fa-eye" aria-hidden="true"></i> ${school.views}</span>
								</div>
								<div class="content-wrapper">
									<div class="school-basic-wrapper w-100 d-flex justify-content-between">
										<div class="title-add-container d-flex flex-column position-relative">
											<a href="${school.final_url}"
											class="school-heading text-truncate text-decoration-none text-black font-weight-bold w-100 notranslate"
											target="_blank">${school.name}</a>
											<a
												href="https://www.google.com/maps/place/${school.slat}+${school.slon}/@${school.slat},${school.slon},18z"
												title="${schoolAddress}"
												class="text-decoration-none text-black d-block school-address text-truncate w-100" target="_blank">
												<i class="fa fa-map-marker text-red" aria-hidden="true"></i> ${schoolAddress}</a>											
										</div>
										<div class="adm-shortlist-container d-flex">
											${!isMobileView && school.admopen ? `<div class="admission-image position-relative">
												<img
												src="${HOST}/search-new/search-page-images/icons/admission-open.svg"
												width="62"
												height="49"
												loading="lazy"
												alt="${school.name} Admission Open">
												</div>` : ''}
											<div class="shortlist" data-school-id="${school.id}">
												<i class="fa ${school.wishlist_status ? 'fa-heart' : 'fa-heart-o'} text-red wishlist-school"></i>
											</div>
										</div>
									</div>	
									<div class="school-fee-rating-wrapper d-flex">
										${!isMobileView ? `<div class="school-fee d-flex flex-row-reverse align-items-baseline">
											<span class="text-gray text-gray-60">${feesTypeWeb}</span>
											<span class="font-weight-bold text-red">${feesAmount ? `${getFormattedFees(school)}` : 'N/A'}</span>
										</div>` : ''}
										<div class="rating-review-container d-flex align-items-center">
											<span class="rating">${parentRating ? parentRating : 'N/A'}<?php echo !empty($parentRating) ?$parentRating : 'N/A'; ?></span>
											<div class="rating-star position-relative">
											<i data-star="${parentRating ? parentRating : 0}" class="basic yellow"></i>
											</div>
											<span class="reviews common-reviews-counter">
												${!!rateCount ? `${rateCount} ${rateCount === 1 ? 'vote': 'votes'}`: '(0 votes)'}									  
											</span>
										</div>
									</div>
									${isMobileView ? `<span class="school-type-badge">${school.typeid_text}</span>` : ''}
									${!isMobileView ? `<div class="school-features d-flex flex-wrap text-center">
											<div class="d-none d-lg-flex flex-column feature-wrapper">
												<span>School Type</span>
												<span class="font-weight-bold">${school.typeid_text ? school.typeid_text : "N/A"}</span>
											</div>
										${schoolFeatures}
									</div>` : ''}
									${!isMobileView ? `<div class="school-action-container d-flex justify-content-between align-items-center">
										${school.owner ? `<img src="${HOST}/search-new/search-page-images/icons/verified.svg"
											width="67" height="60" loading="lazy"
											alt="page managed by school stamp">` : ''}
										<div class="school-action-wrapper d-flex ml-auto">
											${school.subscription_status ? `<a href="tel:${schoolPhoneNumber}" class="btn btn-call"><i class="fa fa-phone" aria-hidden="true"></i> Call</a>` : ''}
											<a href="${school.final_url}" target="_blank" class="btn btn-school-view">View School</a>
											${school.admission_open_button ? `<a href="${school.final_url}/registration" class="btn btn-school-registration">Online Registration</a>`: ''}
										</div>
									</div>`: ''}					
								</div>
						</div>
						${isMobileView ? `<div class="school-features d-flex flex-wrap text-center ${!!boards && boards.length > 15 ? 'many_boards' : ''}">
							<div class="d-flex flex-column feature-wrapper">
								<span>${feesType} Fees</span>
								<span class="font-weight-bold text-red">${feesAmount ? `${getFormattedFees(school)}` : 'N/A'}</span>
							</div>
							${schoolFeatures}
						</div>` : ''}
						<div class="w-100 d-flex flex-column-reverse flex-lg-column expert-actions-container">
							${isMobileView ? `<div class="school-action-container d-flex justify-content-between align-items-center">
								${school.owner ? `<img src="${HOST}/search-new/search-page-images/icons/verified.svg"
								 width="67" height="60" loading="lazy"
								 alt="page managed by school stamp">` : ''}							
								<div class="school-action-wrapper d-flex">
									${school.subscription_status ? `<a href="tel:${schoolPhoneNumber}" class="btn btn-call"><i class="fa fa-phone" aria-hidden="true"></i> Call</a>` : ''}
									<button onclick="openUrlInNewTab('${school.final_url}')" class="btn btn-school-view">View School</button>
								</div>
								</div>` : ''}
							${school.seo_comment ? `<p class="school-expert-comment mb-0"><b>Expert Comment:</b> ${readMoreCommentWeb(school.seo_comment, 'Read More', school.id, `${isMobileView ? 60 : 170}`)}</p>` : ''}	
						</div>
						${isMobileView && school.distance ? `<span class="distance-near-by text-truncate position-absolute text-white d-inline-block">
							<i class="fa fa-compass"></i> ${school.distance} KM</span>` : ''}
						${isMobileView && school.admopen ? `<span class="mobile-adm-open position-absolute  d-inline-block"><span>Admission Open</span></span>` : ''}
					</div>
				</div>`;
}

function readMoreComment() {
	/*$('.expert-comment').expander({
			slicePoint: 170,
			expandText: 'Read More...',
			expandPrefix: ' ',
			userCollapseText: 'Read Less',
	});*/

		function readMoreComment(id){
				let moreText = document.getElementById(`restContent${id}`);
				let btnText = document.getElementById(`readMoreButton${id}`);

				if (moreText.hasClass('d-none')) {
						btnText.innerHTML = "Read more...";
						moreText.removeClass('d-none').addClass('d-inline-block');
				} else {
						btnText.innerHTML = "Read Less";
						moreText.removeClass('d-inline-block').addClass('d-none');
				}
		}

		$('.expert-comment-link').off('click').on('click', function(e){
				e.stopPropagation();
				e.preventDefault();
				let readMoreButton = $(this);
				let schoolId = readMoreButton.attr('data-id');
				let moreText = $(`#restContent${schoolId}`);
				let readMoreDots = $(`#readMoreDots${schoolId}`);

				if (moreText.hasClass('d-none')) {
						readMoreDots.addClass('d-none');
						readMoreButton.text(" Read Less");
						moreText.removeClass('d-none');
				} else {
						readMoreDots.removeClass('d-none');
						readMoreButton.text(" Read more");
						moreText.addClass('d-none');
				}
		})

		$('.expert-comment-link-mobile').off('click').on('click', function(e){
				e.stopPropagation();
				e.preventDefault();
				let readMoreButton = $(this);
				let schoolId = readMoreButton.attr('data-id');
				let moreText = $(`#restContentMobile${schoolId}`);

				if (moreText.hasClass('d-none')) {
						readMoreButton.text(" Read Less");
						moreText.removeClass('d-none');
				} else {
						readMoreButton.text(" Read Expert Comment");
						moreText.addClass('d-none');
				}
		})

		/*$('.expert-comment-mobile.has-data').expander({
				slicePoint: 0,
				expandText: 'Read Expert Comment',
				expandPrefix: ' ',
				userCollapseText: 'Read Less',
		});*/

	if (DEBUG) console.log('runn');

}

function bindWishListClicks() {
		$(".shortlist").off().on('click', function (event) {
				event.stopPropagation();
				if ($(this).find("i").hasClass('fa-heart-o')) {
						addWishlist($(this).attr('data-school-id'), (value) => {
								setWishlistStatus(this);
								if (DEBUG) console.log(value);
						});
				} else {
						removeWishlist($(this).attr('data-school-id'), (value) => {
								setWishlistStatus(this);
								if (DEBUG) console.log(value);
						});
				}
		});
}

const setWishlistStatus = (elm) => {
		getWishlistBySchool($(elm).attr('data-school-id'), (value) => {
				if (value && $(elm).find("i").hasClass('fa-heart-o')) {
						$(elm).find("i").removeClass('fa-heart-o');
						$(elm).find("i").addClass('fa-heart');
				} else if (!value && $(elm).find("i").hasClass('fa-heart')) {
						$(elm).find("i").removeClass('fa-heart');
						$(elm).find("i").addClass('fa-heart-o');
				}
				loadWishlist();
		});
};


function getPlaceholderSchoolCardUI() {
		return `<div class="col-12 school-details-wrapper loading-effect edu-12345">
    <div class="school-card-wrapper position-relative" id="school_12345">
        <div class="d-flex school-card-container">
            <div class="img-btn-wrapper w-100 position-relative">               
                ${true && !isMobileView ? `<span class="distance-near-by position-absolute text-truncate text-white d-block">5 KM</span>` : ''}
                <span class="d-block position-absolute text-white viewed-by text-center"><i class="fa fa-eye" aria-hidden="true"></i> 1500</span>
            </div>
            <div class="content-wrapper">
                <div class="school-basic-wrapper w-100 d-flex justify-content-between">
                    <div class="title-add-container d-flex flex-column position-relative">
                        <a href="javascript:void()"
                           class="school-heading text-truncate text-decoration-none text-black font-weight-bold w-100 notranslate"
                           title="Example School"
                           data-toggle="tooltip"
                           data-placement="top"
                           target="_blank">Example School</a>
                        <a href="javascript:void()"
                           title="123 Example St, City, Country"
                           class="text-decoration-none text-black d-block school-address text-truncate w-100">
                           <i class="fa fa-map-marker text-red" aria-hidden="true"></i> 123 Example St, City, Country</a>
                    </div>
                    <div class="adm-shortlist-container d-flex">
                        ${!isMobileView && true ? `<div class="admission-image position-relative">
                            <img
                            src="${HOST}/search-new/search-page-images/icons/admission-open.svg"
                            width="62"
                            height="49"
                            loading="lazy"
                            alt="Example School Admission Open">
                            </div>` : ''}                       
                    </div>
                </div>
                <div class="school-fee-rating-wrapper d-flex">
                    ${!isMobileView ? `<div class="school-fee d-flex flex-row-reverse align-items-baseline">
                        <span class="text-gray text-gray-60">/ month</span>
                        <span class="font-weight-bold text-red">₹100000</span>
                    </div>` : ''}
                    <div class="rating-review-container d-flex align-items-center">
                        <span class="rating">4.5</span>
                        <div class="rating-star position-relative">
                            <i data-star="4.5" class="basic yellow"></i>
                        </div>
                        <span class="reviews common-reviews-counter">
                            100 votes
                        </span>
                    </div>
                </div>
                ${isMobileView ? `<span class="school-type-badge">Public School</span>` : ''}
                ${!isMobileView ? `<div class="school-features d-flex flex-wrap text-center">
                    <div class="d-none d-lg-flex flex-column feature-wrapper border-0">
                        <span>School Type</span>
                        <span class="font-weight-bold">Public School</span>
                    </div>
                    <div class="d-flex flex-column feature-wrapper border-0">
                        <span>Board</span>
                        <span class="font-weight-bold">CBSE</span>
                    </div>
                    <div class="d-flex flex-column feature-wrapper border-0">
                        <span>Gender</span>
                        <span class="font-weight-bold">Co-Ed</span>
                    </div>
                    <div class="d-flex flex-column feature-wrapper border-0">
                        <span>Grade</span>
                        <span class="font-weight-bold">1-12</span>
                    </div>
                </div>` : ''}
                ${!isMobileView ? `<div class="school-action-container d-flex justify-content-between align-items-center">
                    ${true ? `<img src="${HOST}/search-new/search-page-images/icons/verified.svg"
                        width="67" height="60" loading="lazy"
                        alt="page managed by school stamp">` : ''}
                    <div class="school-action-wrapper d-flex ml-auto">
                        ${true ? `<a href="javascript:void()" class="btn btn-call"><i class="fa fa-phone" aria-hidden="true"></i> Call</a>` : ''}
                        <a href="javascript:void()" target="_blank" class="btn btn-school-view">View School</a>
                        ${true ? `<a href="javascript:void()" class="btn btn-school-registration">Online Registration</a>`: ''}
                    </div>
                </div>` : ''}
            </div>
        </div>
        ${isMobileView ? `<div class="school-features d-flex flex-wrap text-center">
            <div class="d-flex flex-column feature-wrapper border-0">
                <span>Annual Fee</span>
                <span class="font-weight-bold text-red">₹100000</span>
            </div>
            <div class="d-flex flex-column feature-wrapper border-0">
                <span>Board</span>
                <span class="font-weight-bold">CBSE</span>
            </div>
            <div class="d-flex flex-column feature-wrapper border-0">
                <span>Gender</span>
                <span class="font-weight-bold">Co-Ed</span>
            </div>
            <div class="d-flex flex-column feature-wrapper border-0">
                <span>Grade</span>
                <span class="font-weight-bold">1-12</span>
            </div>
        </div>` : ''}
        <div class="w-100 d-flex flex-column-reverse flex-lg-column expert-actions-container">
            ${isMobileView ? `<div class="school-action-container d-flex justify-content-between align-items-center">
                ${true ? `<img src="${HOST}/search-new/search-page-images/icons/verified.svg"
                     width="67" height="60" loading="lazy"
                     alt="page managed by school stamp">` : ''}							
                <div class="school-action-wrapper d-flex">
                    ${true ? `<a href="javascript:void()" class="btn btn-call"><i class="fa fa-phone" aria-hidden="true"></i> Call</a>` : ''}
                    <a href="javascript:void()" target="_blank" class="btn btn-school-view">View School</a>
                    ${true ? `<a href="javascript:void()" class="btn btn-school-registration">Online Registration</a>` : ''}
                </div>
            </div>` : ''}
            ${true ? `<p class="school-expert-comment mb-0"><b>Expert Comment:</b> This is an expert comment about the example school. <a href="#">Read More</a></p>` : ''}
        </div>
        ${isMobileView && true ? `<span class="distance-near-by position-absolute text-white d-inline-block">
            <i class="fa fa-compass"></i> 5 KM</span>` : ''}
    </div>
</div>
`;
}

function NewZealandLead() {
		let NewZealandHTML = `<div class="school-details-wrapper col-lg-12 counsellor-block overflow-hidden" onclick="window.open('https://www.edustoke.com/m1-registration?source=edustoke_search_seo_page')">
														<div class="school-card-wrapper">
															<img data-src="${HOST + '/assets/img/banner/millenium-registration.jpg'}" class="img-fluid lazyload d-none d-md-block" alt="Edustoke">
															<img data-src="${HOST + '/assets/img/banner/millenium-registration-mob.png'}" class="img-fluid lazyload d-block mx-auto  d-md-none" alt="Edustoke">
														</div>													
													</div>`;
		if ((pageVisitType !== 'SEARCH') && ([1, 3, 4].includes(parseInt(schoolType)))) {

				// if ($('.school-details-wrapper.counsellor-block').length === 0) $('.school-details-wrapper').eq(3).after(NewZealandHTML); // show add on 4rd school
				// if ($('.school-details-wrapper.counsellor-block').length === 1) $('.school-details-wrapper').eq(8).after(NewZealandHTML); // show add on 10th school
				// if ($('.school-details-wrapper.counsellor-block').length === 2) $('.school-details-wrapper').eq(17).after(NewZealandHTML); // show add on 20th school

		}
}

function updateHeadingRangeSlider(rangeMin, rangeMax) {
		if(!window.location.href.includes('range_max')){
				sessionStorage.removeItem('updateRangeSliderHeading');
		}
		let updateRangeSliderHeading = sessionStorage.getItem('updateRangeSliderHeading');
		let searchSessionData = JSON.parse(localStorage.getItem('searchSessionData'));
		let homepageSearchSession = sessionStorage.getItem('homepageSearchSession');
		if ([1, 2, 5].includes(parseInt(schoolType)) && pageVisitType === 'SEARCH') {
				let schoolTypeName = getSchoolTypeName(parseInt(schoolType)).replace('-', ' ')
						.replace(/^(.)|\s(.)/g, function ($text) {
								return $text.toUpperCase()
						});

				let formattedAddress = '';

				if (!!searchSessionData && !homepageSearchSession) {
						if (searchSessionData.hasOwnProperty('searchPlaceLocationData'))
								formattedAddress = searchSessionData.searchPlaceLocationData.formatted_address;
				}

				let cityName = $('#city_name').val().replace('-', ' ')
						.replace(/^(.)|\s(.)/g, function ($text) {
								return $text.toUpperCase()
						});
				let city2Name = $('#city_2_name').val().replace('-', ' ')
						.replace(/^(.)|\s(.)/g, function ($text) {
								return $text.toUpperCase()
						});

				const {city_name: spCityName = null, locality_obj = {}} = searchParamsObj || {};
				const {name: localityName = null} = locality_obj || {};
				let address = '';
				if (!!formattedAddress) address = formattedAddress;

				if (!formattedAddress) address = cityName;
				if (!formattedAddress && !cityName) address = city2Name;

				if (!!homepageSearchSession && (localityName || spCityName)){
						let addrArr = [];

						if(localityName) addrArr.push(localityName);
						if(spCityName) addrArr.push(spCityName);

						address = addrArr.join(', ');
				}

				let searchTitle = '';

				if(window.location.href.includes('state_name')){
						let stateName = $('#state_name').val();
						if(!!stateName) searchTitle = `${schoolTypeName} List From ${textCapitalize(stateName)}`;
				}else{
						if(!!updateRangeSliderHeading || window.location.href.includes('range_max')){
								searchTitle = `${schoolTypeName} Within ${rangeMin}-${rangeMax} Kms. From ${textCapitalize(address)}`;
						}else {
								searchTitle = `${schoolTypeName} List From ${textCapitalize(address)}`;
						}
				}

				$('h1.sorting-title').text(`${searchTitle}`);
		}
}


function openFirstFilter(){

		if(pageVisitType === 'DEDICATED_SEARCH_PAGE'){

				if (window.performance) {
						let navEntries = window.performance.getEntriesByType('navigation');
						if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
								window.location.reload();
								if(DEBUG) console.log('As per API lv2, this page is load from back/forward');
						} else if (window.performance.navigation
								&& window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
								if(DEBUG) console.log('As per API lv1, this page is load from back/forward');
						} else {
							if(DEBUG)	console.log('This is normal page load');
						}
				} else {
						if(DEBUG) console.log("Unfortunately, your browser doesn't support this API");
				}

				$('.filter-container input').prop('checked', false);
		}

		let getSelectedFilters = $('.filter-wrapper input:checked');
		if(getSelectedFilters.length){
				getSelectedFilters.each((i, input) =>{
						let inputContainer = $(input).closest('.collapse');
						if(!inputContainer.hasClass('show')){
								inputContainer.prev().trigger('click');
						}
				});
		}else{
				if(window.location.href.includes('range_max') && $('#distance-range-slider-1').length){
						let inputContainer = $('#distance-range-slider-1').closest('.collapse');
						if(!inputContainer.hasClass('show')){
								inputContainer.prev().trigger('click');
						}

				}else{
						if($('.filter-wrapper').length){
								let firstFilter = $('.filter-wrapper:visible:not(.applied-filter-wrapper):first');
								if(!firstFilter.find('.filter-name').next().hasClass('show')){
										firstFilter.find('.filter-name ').trigger('click');
								}
						}
				}
		}
}


function updateDistanceRangeSliderDataOnInput(data){
		let distanceRangeSliderInput = $('#distance-range-slider-1');
		distanceRangeSliderInput.attr('data-from', data.from);
		distanceRangeSliderInput.attr('data-to', data.to);
}


function readMoreCommentWeb(content,link,id, limit) {
		let contentLength = content.length;
		if(contentLength <= limit) return content;
		let lessContent = content.substring(0,limit);
		let restContent = content.substring(limit,contentLength);
		content = `${lessContent}<span class='d-none' id='restContent${id}'>${restContent}</span><span id='readMoreDots${id}'>...</span><a href='javascript:void()' class='expert-comment-link' data-id='${id}'> ${link}</a>`	;
		return content;
}


function readMoreCommentMobile(content,link,id) {
		let restContent =content.substring(0,content.length);
		content =`<span class='d-none' id='restContentMobile${id}'><b>Expert Comment :</b> ${restContent}</span><a href='javascript:void()' class='expert-comment-link-mobile' data-id='${id}'> ${link}</a>`;
		return content;
}


function updateBoardingSchoolFilterTitle(schoolType, searchParams) {
		if (parseInt(schoolType) === 3 && pageVisitType === 'SEARCH') {
				let region = [];
				if(searchParams.hasOwnProperty('region_id_arr')) region = searchParams.region_id_arr;
				let headingTitle = '';
				if (region.length > 1) {
						headingTitle = 'Boarding School List';
				}else if (region.length === 1) {
						headingTitle = `Boarding School List in ${textCapitalize(getRegionName(region[0]), window.location.href)}`;
				}else if (window.location.href.includes('city_name')) {
						let cityName = getParameterByName('city_name');
						if (!!cityName) headingTitle = `Boarding List School in ${textCapitalize(cityName, window.location.href)}`
				} else if (window.location.href.includes('state_name')) {
						let stateName = getParameterByName('state_name');
						if (!!stateName) headingTitle = `Boarding List School in ${textCapitalize(stateName, window.location.href)}`
				}else{
						headingTitle = 'Boarding School List in India';
				}
				if (!!headingTitle) $('.search_heading').text(`${headingTitle}`);
		}
}

